import { render, staticRenderFns } from "./UserLikes.vue?vue&type=template&id=368cd64e&scoped=true"
import script from "./UserLikes.vue?vue&type=script&lang=js"
export * from "./UserLikes.vue?vue&type=script&lang=js"
import style0 from "./UserLikes.vue?vue&type=style&index=0&id=368cd64e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368cd64e",
  null
  
)

export default component.exports